export function getRoundDate(date) {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
}

export function addDay(date, count) {
	let newDate = getRoundDate(date);
	newDate.setDate(date.getDate() + count);
	return newDate;
}



// WEBPACK FOOTER //
// ./src/components/DateFunctions.js